import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";
import {IconButton} from "./IconButton";

// SVG path `d` data (24x24 viewBox) for the icons. These are Material's
// "fullscreen" / "fullscreen_exit" glyphs as sensible defaults — swap the
// strings for your own paths (anything drawSvgPath understands) without
// touching the layout below.
const EXPAND_ICON = "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z";
const COLLAPSE_ICON = "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z";

const GAP = 4;

// a horizontal row of borderless icon buttons for navigating a 2d scene. Shows
// an expand button when `expand` is supplied and a collapse button when
// `collapse` is supplied. Laid out left-to-right; the layout engine positions
// the whole row (e.g. absolute top-right) via this thing's `graphic` bounds.
export class NavButtons extends DrawFrmThing {

    // top-left corner of the row, so callers can link/position it.
    anchor: FrmRefPoint;

    constructor(opts: {
        expand?: () => void;
        collapse?: () => void;
    }) {
        super();

        const buttons: IconButton[] = [];
        if (opts.expand) buttons.push(new IconButton({path: EXPAND_ICON, onClick: opts.expand}));
        if (opts.collapse) buttons.push(new IconButton({path: COLLAPSE_ICON, onClick: opts.collapse}));

        // lay the buttons out in a row. Each button's graphic is a child of this
        // thing's graphic, so DrawFrmThing.destroy({children:true}) tears them
        // down — no need to track() them (they hold no own subscriptions).
        let x = 0;
        for (const b of buttons) {
            b.graphic.position.set(x, 0);
            this.graphic.addChild(b.graphic);
            x += b.size + GAP;
        }

        this.anchor = this.makeRef("navButtons", 0, 0);
    }
}
